import { Directive, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[latinOnly]',
})
export class LatinOnlyDirective {
  @Output() ngModelChange: EventEmitter<string> = new EventEmitter<string>();
  constructor(private _el: ElementRef<HTMLInputElement>, private control: NgControl) { }
  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initialValue.replace(/[^a-zA-Z0-9`~!@#$%^&*()-_=+;:'",<.>/?|]*/g, '');
    this.ngModelChange.emit(this._el.nativeElement.value);
    if (
      this._el.nativeElement.minLength !== -1
      && this._el.nativeElement.value.length < this._el.nativeElement.minLength
    ) {
      this.control.control.setErrors({
        minlength: {
          requiredLength: this._el.nativeElement.minLength,
          actualLength: this._el.nativeElement.value.length,
        },
      });
    }
    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
